import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import { useAuth } from '../contexts/AuthContext';
import { landingPath } from '../utils/permissionUtils';
import COMPANY from '../legal/company';

/**
 * An address that is none of the app's screens (a mistyped link, an old bookmark, a scanner looking for /wordpress). The server answers these
 * with status 404 and this page, rather than a bare error; someone signed in is offered their own home, anyone else the front page.
 */
function NotFound() {
  const { user } = useAuth();

  useEffect(() => {
    document.title = `Page not found - ${COMPANY.brand}`;
    return () => { document.title = COMPANY.brand; };
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <PublicHeader />
      <Container className="py-5 flex-grow-1 text-center" style={{ maxWidth: '36rem' }}>
        <div className="display-4 text-muted mb-2" aria-hidden="true"><i className="bi bi-compass" /></div>
        <h1 className="h3">We can&apos;t find that page</h1>
        <p className="text-muted">
          The address may have been typed wrongly, or the page may have moved. Nothing is wrong with your account or your data.
        </p>
        <div className="d-flex flex-wrap justify-content-center gap-2">
          {user
            ? <Link to={landingPath(user)} className="btn btn-primary">Back to my home screen</Link>
            : <Link to="/" className="btn btn-primary">Go to the front page</Link>}
          <Link to="/contact" className="btn btn-outline-secondary">Contact us</Link>
        </div>
      </Container>
      <PublicFooter />
    </div>
  );
}

export default NotFound;
